import { render } from "./ListarReceitasPlanos.vue?vue&type=template&id=524f7e89&scoped=true"
import script from "./ListarReceitasPlanos.vue?vue&type=script&lang=js"
export * from "./ListarReceitasPlanos.vue?vue&type=script&lang=js"

import "./ListarReceitasPlanos.vue?vue&type=style&index=0&id=524f7e89&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524f7e89"]])

export default __exports__